import React from 'react';

const ShareIcon = () => (
  <svg className="icon icon-share" width="20" height="16" viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
    <g id="New-BCOM-Styles" fill="none" fillRule="evenodd">
      <g id="BCOM_Level2_Edited_Sidebar_CECrPreShare" transform="translate(-1111 -323)">
        <g id="Group-3" transform="translate(1109 319)">
          <g id="Group-7">
            <g id="envelope-icon">
              <path
                d="M20,4 L4,4 C2.9,4 2.01,4.9 2.01,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 C22,4.9 21.1,4 20,4 Z M20,8 L12,13 L4,8 L4,6 L12,11 L20,6 L20,8 Z"
                id="Shape"
                className="f0"
                fill="#3455DB"
                fillRule="nonzero"
              />
              <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ShareIcon;
